<template>
    <div class="tax-credit-invoice-advance-four-section-layout">
        <div class="actions">
            <el-button icon="el-icon-plus" @click="openAll"> 展開 </el-button>
            <el-button icon="el-icon-minus" @click="closeAll"> 收闔 </el-button>

            <el-button @click="$emit('switch')"> 薪資切換（成本 / 費用） </el-button>
        </div>
        <div class="adv-summary-grid" :class="{ hideDetail: !isShowDetails }">
            <section class="adv-summary-section">
                <table cellspacing="0">
                    <thead>
                        <tr class="title-thead">
                            <th></th>
                            <th>總計</th>
                            <th>佔總收入%</th>
                        </tr>
                        <tr class="first-thead">
                            <td class="title block-title">收入</td>
                            <td class="money-block">
                                <Money :v="totalIncome" round />
                            </td>
                            <td class="percentage">
                                <div>100%</div>
                            </td>
                        </tr>
                    </thead>
                    <tbody v-if="isShowDetails">
                        <tr v-for="item in invoiceData" :key="item.iteM_SNO">
                            <td class="title">{{ item.iteM_NAM }}</td>
                            <td class="money-block">
                                <Money :v="getTotalAmt(item)" round />
                            </td>
                            <td class="percentage">{{ getPercentage(getTotalAmt(item), totalIncome) }}%</td>
                        </tr>
                    </tbody>
                </table>
            </section>
            <section class="adv-summary-section">
                <table cellspacing="0">
                    <thead>
                        <tr class="title-thead">
                            <th></th>
                            <th>總計</th>
                            <th>佔總收入%</th>
                        </tr>
                        <tr class="first-thead">
                            <td class="title block-title">成本</td>
                            <td class="money-block">
                                <Money :v="totalCost" round />
                            </td>
                            <td class="percentage">
                                <div>{{ getPercentage(totalCost, totalIncome) }}%</div>
                            </td>
                        </tr>
                    </thead>
                    <tbody v-if="isShowDetails">
                        <tr v-for="item in costList" :key="item.iteM_SNO">
                            <td class="title">{{ item.iteM_NAM }}</td>
                            <td class="money-block">
                                <Money :v="getTotalAmt(item)" round />
                            </td>
                            <td class="percentage">{{ getPercentage(getTotalAmt(item), totalIncome) }}%</td>
                        </tr>
                    </tbody>
                </table>
            </section>
            <section class="adv-summary-section">
                <table cellspacing="0">
                    <thead>
                        <tr class="title-thead">
                            <th></th>
                            <th>總計</th>
                            <th>佔總收入%</th>
                        </tr>
                        <tr class="first-thead">
                            <td class="title block-title">稅前淨利</td>
                            <td class="money-block">
                                <Money :v="totalNet" round />
                            </td>
                            <td class="percentage">
                                <div>{{ getPercentage(totalNet, totalIncome) }}%</div>
                            </td>
                        </tr>
                    </thead>
                    <tbody v-if="isShowDetails">
                        <tr>
                            <td class="title">＋收入</td>
                            <td class="money-block">
                                <Money :v="totalIncome" round />
                            </td>
                            <td class="percentage">{{ getPercentage(totalIncome, totalIncome) }}%</td>
                        </tr>
                        <tr>
                            <td class="title">－成本</td>
                            <td class="money-block">
                                <Money :v="totalCost" round />
                            </td>
                            <td class="percentage">{{ getPercentage(totalCost, totalIncome) }}%</td>
                        </tr>
                        <tr>
                            <td class="title">＝毛利</td>
                            <td class="money-block">
                                <Money :v="totalIncome - totalCost" round />
                            </td>
                            <td class="percentage">{{ getPercentage(totalIncome - totalCost, totalIncome) }}%</td>
                        </tr>
                        <tr>
                            <td class="title">－費用</td>
                            <td class="money-block">
                                <Money :v="totalFee" round />
                            </td>
                            <td class="percentage">{{ getPercentage(totalFee, totalIncome) }}%</td>
                        </tr>
                    </tbody>
                </table>
            </section>
            <section class="adv-summary-section">
                <table cellspacing="0">
                    <thead>
                        <tr class="title-thead">
                            <th></th>
                            <th>總計</th>
                            <th>佔總收入%</th>
                        </tr>
                        <tr class="first-thead">
                            <td class="title block-title">費用</td>
                            <td class="money-block">
                                <Money :v="totalFee" round />
                            </td>
                            <td class="percentage">
                                <div>{{ getPercentage(totalFee, totalIncome) }}%</div>
                            </td>
                        </tr>
                    </thead>
                    <tbody v-if="isShowDetails">
                        <tr v-for="item in feeList" :key="item.iteM_SNO">
                            <td class="title">{{ item.iteM_NAM }}</td>
                            <td class="money-block">
                                <Money :v="getTotalAmt(item)" round />
                            </td>
                            <td class="percentage">{{ getPercentage(getTotalAmt(item), totalIncome) }}%</td>
                        </tr>
                    </tbody>
                </table>
            </section>
        </div>
    </div>
</template>

<script>
import _ from 'lodash';

export default {
    props: {
        invoiceData: {
            type: Array,
            default: () => [],
        },
        paymentData: {
            type: Array,
            default: () => [],
        },
        salaryData: {
            type: Object,
            default: () => {},
        },
        isSalaryCost: Boolean,
    },
    data() {
        return {
            isShowDetails: true,

            activeIncome: [],
            activeCost: [],
            activeNet: [],
            activeFee: [],
        };
    },
    computed: {
        totalIncome() {
            return _.sumBy(this.invoiceData, (o) => o.actuallyAmount + o.nonProjectAmount + o.projectAmount + o.futureAmt);
        },
        totalNet() {
            return this.totalIncome - this.totalCost - this.totalFee;
        },
        costList() {
            const RETURN = _.chain(this.paymentData)
                .filter(['grP_NAM', 5])
                .value();
            if (this.isSalaryCost) {
                RETURN.push({
                    iteM_NAM: '薪資支出',
                    actuallyAmount: this.salaryData.salaryAmount + this.salaryData.bonusAmount,
                    nonProjectAmount: 0,
                    projectAmount: 0,
                    futureAmt: 0,
                });
            }
            return RETURN;
        },
        totalCost() {
            return _.sumBy(this.costList, (o) => o.actuallyAmount + o.nonProjectAmount + o.projectAmount + o.futureAmt);
        },
        feeList() {
            const RETURN = _.chain(this.paymentData)
                .filter(['grP_NAM', 6])
                .value();
            RETURN.push({
                iteM_NAM: '人事費用',
                actuallyAmount: this.salaryData.staffCost,
                nonProjectAmount: 0,
                projectAmount: 0,
                futureAmt: 0,
            });
            if (!this.isSalaryCost) {
                RETURN.push({
                    iteM_NAM: '薪資支出',
                    actuallyAmount: this.salaryData.salaryAmount + this.salaryData.bonusAmount,
                    nonProjectAmount: 0,
                    projectAmount: 0,
                    futureAmt: 0,
                });
            }
            return RETURN;
        },
        totalFee() {
            return _.sumBy(this.feeList, (o) => o.actuallyAmount + o.nonProjectAmount + o.projectAmount + o.futureAmt);
        },
    },
    methods: {
        getPercentage(value, total) {
            if (!value || !total) return '--';
            return Math.round((value / total) * 10000) / 100;
        },
        getTotalAmt(row) {
            return row.actuallyAmount + row.nonProjectAmount + row.projectAmount + row.futureAmt;
        },

        openAll() {
            this.isShowDetails = true;
            this.activeIncome = 'item';
            this.activeCost = 'item';
            this.activeNet = 'item';
            this.activeFee = 'item';
        },
        closeAll() {
            this.isShowDetails = false;
            this.activeIncome = [];
            this.activeCost = [];
            this.activeNet = [];
            this.activeFee = [];
        },
    },
};
</script>

<style lang="scss">
@import "@/assets/scss/vars.scss";
.tax-credit-invoice-advance-four-section-layout {
    @media print {
        display: none;
    }
    .actions {
        margin: 0 0 15px 0;
        display: flex;
        justify-content: flex-end;
    }
    .data-content {
        &.isHideDetails {
            .ah-container {
                padding: 0 25px;
            }

            > * {
                width: calc(50% - 30px / 2);
                border: 1px solid #d7d7d7;
                &:nth-child(even) {
                    margin-left: 10px;
                }
            }
        }

        .ah-container {
            transition: 0.2s;
            padding: 30px 35px;
            .el-collapse-item__header,
            .el-collapse-item__content {
                font-size: inherit;
            }
            .el-collapse-item__wrap,
            .el-collapse {
                border: 0;
            }
        }
        .panel-header {
            padding-right: 10px;
            border: 0;
            .title {
                color: $main-color;
                font-weight: bold;
            }
        }
        .body {
            padding-top: 15px;
            border-top: 1px solid #eee;
        }
    }

    .adv-summary-grid {
        @media (min-width: 1000px) {
            display: grid;
            grid-template-columns: 1fr 1fr;
            gap: 30px;
        }

        &.hideDetail {
            gap: 15px;
            .adv-summary-section {
                padding: 20px;

                table {
                    thead {
                        .first-thead td {
                            padding: 0 0 0 0;
                        }
                    }
                }
            }
        }

        .adv-summary-section {
            border: 1px solid #ddd;
            border-radius: 8px;
            padding: 30px;
            margin: 0 0 20px 0;
            box-shadow: 1px 1px 5px rgba(0, 0, 0, 0.1);

            @media (min-width: 1000px) {
                margin: 0;
            }

            table {
                width: 100%;
                font-weight: normal;
                font-size: 11pt;

                thead {
                    .title {
                        color: #463cb2;
                        font-size: 13pt;
                        font-weight: bold;
                    }

                    .title-thead th {
                        text-align: right;
                        font-weight: normal;
                        font-size: 9pt;
                        color: #000;
                    }

                    .first-thead td {
                        padding: 0 0 12px 0;
                        vertical-align: bottom;
                        font-size: 14pt;
                    }
                }

                tbody {
                    tr {
                        &:nth-child(1) {
                            td {
                                border-top: 1px solid #463cb2;
                                padding-top: 15px;
                            }
                        }
                        td {
                            padding: 3px;
                            border-top: 1px solid #eee;
                            font-size: 10.5pt;

                            &.title {
                                padding-left: 20px;
                            }

                            .money {
                                font-weight: normal;
                            }
                        }
                    }
                }

                .percentage {
                    width: 100px;
                    padding-left: 20px;
                    text-align: right;
                }
                .money-block {
                    text-align: right;
                }
            }
        }
    }
}
</style>
